import { type SerializeFrom } from '@remix-run/node'
import { CarDescriptionMobile } from '#app/shared/ui/data-display/carDescription/CarDescriptionMobile.tsx'
import CarPriceCard from '#app/shared/ui/data-display/carDescription/CarPriceCard.tsx'
import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'
import { type loader } from '../route.tsx'

type SoldCar = SerializeFrom<typeof loader>['carlist'][number]

type Props = {
  carlist: SoldCar[]
}

export const SoldCars = ({ carlist }: Props) => {
  if (!carlist?.length) return null

  const slides = carlist.map((car) => (
    <div key={car.id} className="flex justify-center">
      <CarPriceCard car={car as any} />
    </div>
  ))

  return (
    <section
      className={`
        bg-neutral-50 py-16

        lg:py-20
      `}
    >
      <MainContainer
        className={`
          px-4

          sm:px-6

          xl:px-2
        `}
      >
        <SectionEyebrow>Últimas entregas</SectionEyebrow>
        <h2
          className={`
            mb-10 text-h3 text-primary-800

            lg:text-h2
          `}
        >
          Coches que ya encontraron su conductor
        </h2>

        <CarDescriptionMobile slides={slides} />
      </MainContainer>
    </section>
  )
}
